import React, { useLayoutEffect, useContext } from "react";
import { Link } from "react-router-dom";
import ApiScreenshot from "../../../app/api/admin/screenshot/ApiScreenshot";
import Page from "../../modules/page";
import { ContextPage } from "../../modules/page/pageContext";
import { ContextContent } from "../../modules/content/contentContext";
import List from "../../modules/list";
import useListFilters from "../../modules/list/useListFilters";
import InputNumber from "../../components/inputs/number/number";
import Select from "../../components/inputs/select";
import DateLib from "../../../inc/DateLib";
import "./styles.css";

// Откуда снимок (ScreenshotFilter::source на бэкенде). Ключи — значения фильтра и поля source.
export const SOURCE_LABELS = {
    'schedule': 'По расписанию',
    'script': 'Кадр задачи',
};

// Раздел «Скриншоты»: сквозной по ферме read-only список снимков (authorized/admin/screenshots).
// Два источника в одной выдаче — снятые кроном по расписанию и снятые задачей по ходу скрипта,
// различаются полем source. Ради этого эндпоинт и заведён: по /files спросить «снимки устройства
// N» нельзя (см. докблок ApiScreenshot).
//
// Представление — плитка карточек, а не таблица: страницу открывают, чтобы СМОТРЕТЬ кадры, а
// строка таблицы отдавала превью 64px и половину ширины пускала под пустые ячейки. Плитку даёт
// renderList модуля List (тот же приём, что у режима «плитка» на «Устройствах»); фильтры и
// пагинация остаются его же.
//
// Побочный эффект замены таблицы: кликать по заголовкам для сортировки больше негде. Потеря
// невелика — бэкенд вайтлистит только id и created_at (ScreenshotFilter::ORDER_COLUMNS), а
// порядок по умолчанию (свежие первыми) для ленты кадров и есть единственный осмысленный.
export default function ScreenshotsIndex({ ...other }) {
    return <Page {...other}>
        <ScreenshotsIndexContent/>
    </Page>;
}

function ScreenshotsIndexContent() {
    const contextContent = useContext(ContextContent);
    const contextPage = useContext(ContextPage);

    // Фильтры — в URL (useListFilters), как сортировка и страница: на раздел ссылаются со страницы
    // «Устройства» (/screenshots?device_id=N), и переход с другого устройства меняет выдачу уже
    // открытой страницы.
    const filter = useListFilters(['device_id', 'source']);

    useLayoutEffect(() => {
        contextContent.setTitle('Скриншоты');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const filters = [
        <InputNumber className="input_wf" value={filter.values.device_id}
            onChange={(event) => filter.setValue('device_id', event.target.value)}>id устройства</InputNumber>,
        <Select className="input_wf" options={SOURCE_LABELS} value={filter.values.source} isNull={true}
            onChange={(event) => filter.setValue('source', event.target.value)}>Источник</Select>,
    ];

    // Карточка целиком — ссылка на снимок, поэтому внутри неё ссылок БОЛЬШЕ НЕТ: вложенный <a>
    // невалиден и ломает навигацию. Устройство тут просто текст, а кликабельно оно уже в карточке
    // снимка.
    const renderScreenshots = (rows) => {
        if (rows.length === 0) return <div className="screenshots__empty">Снимков не найдено</div>;

        return <div className="screenshots__grid">
            {rows.map((row) => <Link
                key={row.id}
                className="screenshots__tile"
                to={contextPage.routes.show.url({ id: row.id })}
                title={`Открыть снимок #${row.id}`}
            >
                {/* loading="lazy" обязателен: на странице до полусотни полноразмерных кадров. */}
                <img className="screenshots__tile-img" src={row.public_url}
                    alt={`Снимок #${row.id}`} loading="lazy"/>

                <span className="screenshots__tile-caption">
                    <span className="screenshots__tile-head">
                        <span className="screenshots__tile-device">
                            {row.device_id ? `#${row.device_id}` : 'без устройства'}
                        </span>
                        <span className="screenshots__tile-time">
                            {DateLib.formatterDateTime(row.created_at)}
                        </span>
                    </span>
                    <span className="screenshots__muted">
                        {SOURCE_LABELS[row.source] ?? row.source}
                        {/* execute_id бэкенд кладёт ТОЛЬКО при source === 'script'. */}
                        {row.execute_id ? ` · запуск #${row.execute_id}` : ''}
                    </span>
                </span>
            </Link>)}
        </div>;
    };

    return <List
        ApiModel={ApiScreenshot}
        renderList={renderScreenshots}
        filters={filters}
        defaultSortKey="created_at"
        defaultSortIsAsc={false}
        searchParams={filter.applied}
        onApplyFilters={filter.apply}
        onResetFilters={filter.reset}
    />;
}
